const name = 'Dr. Eugene Callahan';
const role = 'Founder and President';
const text = `Gene Callahan has been involved in software development for over thirty years.
He is the author of number of articles on software and software management.
He currently teaches software engineering at New York University.`;

const eugeneCallahan = { name, role, text };

export default eugeneCallahan;
